import React from "react";
import { useI18n } from "../contexts/I18nContext";

// EN | हिं pill toggle. Sits in the navbar.
export default function LanguageToggle({ compact = false }) {
  const { lang, setLang, t } = useI18n();
  const isHi = lang === "hi";

  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0,
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,209,102,0.18)",
        borderRadius: "999px",
        padding: "3px",
        marginRight: compact ? 0 : "8px",
      }}
    >
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        aria-pressed={!isHi}
        style={{
          background: !isHi ? "linear-gradient(135deg, #FFD166, #FFAA33)" : "transparent",
          color: !isHi ? "#120021" : "rgba(255,255,255,0.65)",
          border: "none",
          borderRadius: "999px",
          padding: compact ? "4px 10px" : "5px 12px",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.5px",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
      >
        {t("nav.languageEN")}
      </button>
      <button
        data-testid="lang-toggle-hi"
        onClick={() => setLang("hi")}
        aria-pressed={isHi}
        style={{
          background: isHi ? "linear-gradient(135deg, #FFD166, #FFAA33)" : "transparent",
          color: isHi ? "#120021" : "rgba(255,255,255,0.65)",
          border: "none",
          borderRadius: "999px",
          padding: compact ? "4px 10px" : "5px 12px",
          fontSize: "0.78rem",
          fontWeight: 700,
          letterSpacing: "0.5px",
          cursor: "pointer",
          transition: "all 0.2s ease",
          fontFamily: "'Noto Sans Devanagari', 'Inter', sans-serif",
        }}
      >
        {t("nav.languageHI")}
      </button>
    </div>
  );
}
